import { ReusableCustomQuestionGroup } from "../interfaces/ReusableCustomQuestionGroup";
import { WorkflowMetadataGroup } from "../interfaces/Workflow";
import { convertReusableQuestionToWorkflowQuestionField } from "./CustomQuestionFieldUtils";

export function convertReusableQuestionGroupToWorkflowMetadataGroup(
  customQuestionGroup: ReusableCustomQuestionGroup,
): WorkflowMetadataGroup {
  return {
    name: customQuestionGroup.groupName,
    fields: customQuestionGroup.questionList?.map((customQuestionField) =>
      convertReusableQuestionToWorkflowQuestionField(customQuestionField),
    ),
  };
}
